import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

interface GridPosition {
  row: number;
  col: number;
}

type IconState = 'dot' | 'icon' | 'empty';
type Direction = 'row' | 'column';

@Component({
  selector: 'wms-icon-selector-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon-selector-grid.component.html',
})

export class IconSelectorGridComponent {
  @Output() iconChange = new EventEmitter<string>();

  @Input() icons: string[] = [];
  @Input() selectedIcon: string = '';
  @Input() spacing: string = '';
  @Input() direction: Direction = 'row';
  @Input() wrap: boolean = false;

  hoveredIcon: string | null = null;
  positions: GridPosition[] = [
    { row: 0, col: 0 }, { row: 0, col: 1 }, { row: 0, col: 2 },
    { row: 1, col: 0 }, { row: 1, col: 1 }, { row: 1, col: 2 },
    { row: 2, col: 0 }, { row: 2, col: 1 }, { row: 2, col: 2 }
  ];
  autoAlignments: string[] = ["start", "center", "end"];


  constructor() {
  }


  /** Trigger icon selection */
  setIcon(icon: string) {
    this.selectedIcon = icon;
    this.iconChange.emit(icon);
  }

  /** Returns alignment based on row/col and direction */
  getAlignment(position: GridPosition): string {
    const key = this.direction === 'row' ? position.row : position.col;
    return this.autoAlignments[key];
  }

  /** Decide whether to show dot, icon, or nothing */
  shouldShowIcon(position: GridPosition): IconState {
    const alignment = this.getAlignment(position);

    const isHoveredOrSelected = this.hoveredIcon === alignment || this.selectedIcon === alignment;

    if (!isHoveredOrSelected) {
      return 'dot';
    }

    const isMiddle = (this.direction === 'row' && position.col === 1) || (this.direction === 'column' && position.row === 1);
    return isMiddle ? 'icon' : 'empty';

  }

  getIconClass(position: any): string {
    let alignment = position ===  this.selectedIcon ? this.selectedIcon :  this.hoveredIcon;
    if (this.wrap && this.spacing != 'auto') {
      return 'wms-wrap-' + alignment;
    }else if(this.spacing === 'auto'){
      alignment = this.getAlignment(position)
    }
    return 'wms-' + this.direction + '-' + alignment;
  }

}
